import { Stack } from '@mui/material';
import React from 'react'
import { LoadingSection } from '../integrationHelper';
import { BoardView } from './components/boardView';
import { LayoutTitle } from './components/layoutTitle';
import { IBoardLayout } from './types';

export const BoardLayout: React.FC<IBoardLayout> = ({ showLayoutTitle = true, layoutTitleDetails, boardViewDetails }) => {
    return (
        <Stack sx={{
            height: `100%`,
        }} spacing={2}>
             {showLayoutTitle &&
                <LayoutTitle {...layoutTitleDetails} />
            }
            <Stack sx={{ height: `calc(100% - ${showLayoutTitle ? layoutTitleDetails?.showTitle ? 85 : 45 : 0}px)` }}>
                {boardViewDetails.isLoading ? (
                    <LoadingSection message="Building Board View..." />
                ) :
                    <BoardView stack={boardViewDetails.stack} {...boardViewDetails} />}
            </Stack>
        </Stack>
    )
}
